import {Dispatch} from "redux";
import {store} from "../../navigation/ReduxProvider";

export default class Executor {
	/**
	 * Action count to execute
	 * @type {number}
	 */
	actionsNumber: number = 0;
	/**
	 * Actions to execute
	 */
	actions: ((dispatch: Dispatch<any>) => void)[];

	constructor(public readonly onSuccess: (dispatch: Dispatch<any>) => void) {}

	/**
	 * Set actions
	 * @param {((dispatch: Dispatch<any>) => void)[]} actions
	 * @returns {Executor}
	 */
	setActions(actions: ((dispatch: Dispatch<any>) => void)[]): Executor {
		this.actionsNumber = actions.length;
		this.actions = actions;
		return this;
	}

	/**
	 * Start execute actions
	 */
	run() {
		this.actions.forEach(a => store.dispatch(a));
	}

	/**
	 * Action success callback
	 */
	actionSuccess() {
		this.actionsNumber--;
		if (this.actionsNumber) {
			return
		}
		store.dispatch(this.onSuccess)
	}
}